/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiTagsMutationRequest, PostApiTagsMutationResponse, PostApiTags400, PostApiTags401, PostApiTags403, PostApiTags500 } from "../../types/PostApiTags.ts";
import { postApiTagsMutationResponseSchema, postApiTagsMutationRequestSchema } from "../../zod/TagSchemas/postApiTagsSchema.ts";

function getPostApiTagsUrl() {
  const res = { method: 'POST', url: `/api/tags` as const }  
  return res
}

/**
 * @summary Создание жанра
 * {@link /api/tags}
 */
export async function postApiTags({ data }: { data?: PostApiTagsMutationRequest }, config: Partial<RequestConfig<PostApiTagsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiTagsMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiTagsMutationResponse, ResponseErrorConfig<PostApiTags400 | PostApiTags401 | PostApiTags403 | PostApiTags500>, PostApiTagsMutationRequest>({ method : "POST", url : getPostApiTagsUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiTagsMutationResponseSchema.parse(res.data)
}